export const otherSEPermission = {
  drIsOpened24HoursMode: ['read', 'write'],
  dtIsClosedMode: ['read', 'write'],
  dtIsOpened24HoursMode: ['read', 'write'],
  digitalDtIsClosedMode: ['read', 'write'],
  digitalDtIsOpened24HoursMode: ['read', 'write'],
  cateringIsClosedMode: ['read', 'write'],
  dhIsClosedMode: ['read', 'write'],
  curbsideIsClosedMode: ['read', 'write'],
};

export const operationHoursPermission = {
  isCalculated: 'N',
  drTimeOpenMode: ['read', 'write'],
  drTimeCloseMode: ['read', 'write'],
  dtTimeOpenMode: ['read', 'write'],
  dtTimeCloseMode: ['read', 'write'],
  digitalDtTimeOpenMode: ['read', 'write'],
  digitalDtTimeCloseMode: ['read', 'write'],
  deliveryTimeOpenMode: ['read', 'write'],
  deliveryTimeCloseMode: ['read', 'write'],
  curbsideTimeOpenMode: ['read', 'write'],
  curbsideTimeCloseMode: ['read', 'write'],
  cateringTimeOpenMode: ['read', 'write'],
  cateringTimeCloseMode: ['read', 'write'],
};

export const otherBasePermission = {
  breakfastTimeOpenMode: ['read', 'write'],
  breakfastTimeCloseMode: ['read', 'write'],
  lunchTimeOpenMode: ['read', 'write'],
  lunchTimeCloseMode: ['read', 'write'],
  snackTimeOpenMode: ['read', 'write'],
  snackTimeCloseMode: ['read', 'write'],
  dinnerTimeOpenMode: ['read', 'write'],
  dinnerTimeCloseMode: ['read', 'write'],
  lateNightTimeOpenMode: ['read', 'write'],
  lateNightTimeCloseMode: ['read', 'write'],
};

export const servicesPermission = [
  {
    name: 'Catering',
    code: 'catering',
    value: true,
    type: 'toggle',
    category: 'Service mode',
    categoryCode: 'services.serviceMode',
    modes: ['read', 'write'],
  },
  {
    name: 'Curbside Pickup',
    code: 'curbsidePickup',
    value: true,
    type: 'toggle',
    category: 'Service mode',
    categoryCode: 'services.serviceMode',
    modes: ['read', 'write'],
  },
  {
    name: 'Drive Thru',
    code: 'driveThru',
    value: true,
    type: 'toggle',
    category: 'Service mode',
    categoryCode: 'services.serviceMode',
    modes: ['read', 'write'],
  },
  {
    name: 'Digital Drive Thru',
    code: 'digitalDriveThru',
    value: true,
    type: 'toggle',
    category: 'Service mode',
    categoryCode: 'services.serviceMode',
    modes: ['read', 'write'],
  },
];
